__turbopack_context__.v({
  "dot": "styles-module__wPWECG__dot",
  "dotActive": "styles-module__wPWECG__dotActive",
  "dots": "styles-module__wPWECG__dots",
  "embla": "styles-module__wPWECG__embla",
  "embla__container": "styles-module__wPWECG__embla__container",
  "embla__slide": "styles-module__wPWECG__embla__slide",
  "embla__viewport": "styles-module__wPWECG__embla__viewport",
  "fullscreenBtn": "styles-module__wPWECG__fullscreenBtn",
  "gallery": "styles-module__wPWECG__gallery",
  "image": "styles-module__wPWECG__image",
  "imageWrap": "styles-module__wPWECG__imageWrap",
  "navNext": "styles-module__wPWECG__navNext",
  "navPrev": "styles-module__wPWECG__navPrev",
});
